import { useState, useMemo, useContext, createContext } from 'react';

type SessionContextState = [string | undefined, React.Dispatch<React.SetStateAction<string | undefined>>] | null;

const sessionContext = createContext<SessionContextState>(null);

export type SessionProviderProps = {
  error?: string;
  children: React.ReactNode;
};

const useSession = () => {
  const context = useContext(sessionContext);

  if (!context) {
    throw new Error('useSession must be used within a SessionProvider');
  }

  return context;
};

const SessionProvider = ({ error: initialError, children }: SessionProviderProps) => {
  const [error, setError] = useState<string | undefined>(initialError);

  const value = useMemo<[string | undefined, React.Dispatch<React.SetStateAction<string | undefined>>]>(
    () => [error, setError],
    [error]
  );

  return <sessionContext.Provider value={value}>{children}</sessionContext.Provider>;
};

export { SessionProvider, useSession };
